/// <reference path='../_references.ts'/>

module App.HeaderMessages {
	interface Config {
		lastUpdate?: number;
		uid?: number;
		activeMessages?: GlobalMessage[];
	}
	interface LocalStorage extends ng.local.storage.ILocalStorageService {
		headerMessagesConfig?: Config;
		userData?: {id: number};
	}

	const INTERVAL: number = 600000; // 10 Minutes

	export class HeaderMessagesController {
		static $inject: string[] = ['$interval', '$localStorage', 'HeaderMessagesService', 'ToastService'];

		private isSaving: number = 0;
		private toSave: number[] = [];

		constructor(
			protected $interval: ng.IIntervalService,
			protected $localStorage: LocalStorage,
			protected HeaderMessagesService: HeaderMessagesService,
			protected ToastService: App.Utils.ToastService
		) {
			this.$interval(this.update.bind(this), INTERVAL);
			this.update();
		}

		public isDisabled(messageId: number): boolean {
			return this.isSaving === messageId || this.toSave.indexOf(messageId) !== -1;
		}

		public isOpen(): boolean {
			return this.getActiveMessages().length > 0;
		}

		public getActiveMessages(): GlobalMessage[] {
			return (this.$localStorage.headerMessagesConfig || {}).activeMessages || [];
		}

		public update(): void {
			let config: Config = this.$localStorage.headerMessagesConfig || {},
				lastUpdate: number = config.lastUpdate,
				cUId: number = (this.$localStorage.userData || {id: null}).id,
				tUId = config.uid;

			if (!lastUpdate || !tUId || cUId !== tUId || ((new Date()).getTime() - lastUpdate) > (INTERVAL * 0.9)) {
				this.HeaderMessagesService.getActiveMessages()
					.then((response) => {
						let activeMessages = response.data;

						config.lastUpdate = (new Date()).getTime();
						config.activeMessages = activeMessages;
						config.uid = (this.$localStorage.userData || {id: null}).id;

						this.$localStorage.headerMessagesConfig = config;
					});
			}
		}

		public markRead(messageId: number, force?: boolean) {
			if (!force && this.isSaving) {
				this.toSave.push(messageId);
				return;
			}

			this.isSaving = messageId;

			this.HeaderMessagesService.markRead(messageId)
				.then(() => {
					let config: Config = this.$localStorage.headerMessagesConfig || {};

					config.activeMessages = config.activeMessages.filter((message) => {
						return message.id !== messageId;
					});

					this.$localStorage.headerMessagesConfig = config;

					this.toSave = this.toSave.filter((id, index) => id !== messageId && this.toSave.indexOf(id) === index);

					if (this.toSave.length) {
						this.markRead(this.toSave.pop(), true);
					} else {
						this.isSaving = 0;
					}
				})
				.catch((err) => {
					this.ToastService.showError('Failed to mark message as read: ', err);
					this.isSaving = 0;
					this.toSave = [];
				})
		}
	}
}
